function Mudarestado(el) {
  var display = document.getElementById(el).style.display;
  if (display == "none") {
    document.getElementById(el).style.display = 'block';
  }
  else {
    document.getElementById(el).style.display = 'none';
  }
  return

}
let checkboxMonday = document.getElementById('closedMonday');
checkboxMonday.checked ? document.getElementById('op3').style.display = 'none' : ""

let checkboxTuesday = document.getElementById('closedTuesday');
checkboxTuesday.checked ? document.getElementById('op4').style.display = 'none' : ""

let checkboxWednesday = document.getElementById('closedWednesday');
checkboxWednesday.checked ? document.getElementById('op5').style.display = 'none' : ""

let checkboxThursday = document.getElementById('closedThursday');
checkboxThursday.checked ? document.getElementById('op6').style.display = 'none' : ""

let checkboxFriday = document.getElementById('closedFriday');
checkboxFriday.checked ? document.getElementById('op7').style.display = 'none' : ""

let checkboxSaturday = document.getElementById('closedSaturday');
checkboxSaturday.checked ? document.getElementById('op8').style.display = 'none' : ""

let checkboxSunday = document.getElementById('closedSunday');
checkboxSunday.checked ? document.getElementById('op1').style.display = 'none' : ""


